import { BaseRequestModel } from "./BaseModel/BaseRequestModel";
import { PaginationModel } from "./pagination-model";

export class getAllPublicVoilationsRequestModel extends BaseRequestModel{
    procurementPlanDetailID:number
    pagination:PaginationModel;
}